"use strict";

module.exports = {
  type: ['LD50', 'LC50'],
  unit: ['mg/kg', 'mg/L', 'ppmv'],
  animal: ['Rat', 'Rabbit', 'Guinea pig', 'Human'],
  route: ['Oral', 'Dermal', 'Inhalation']
};